import { render, staticRenderFns } from "./TicketReport.vue?vue&type=template&id=065ef0ca"
import script from "./TicketReport.vue?vue&type=script&lang=js"
export * from "./TicketReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports